<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <app-sub-title text="Servicios de Escolta"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-bodyguard-services-filters
                    @filter="onFilter"
                    :export="true"
                ></app-bodyguard-services-filters>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-bodyguard-services-list
                    :data="services"
                    @sort="onSort"
                    @change-page="onChangePage"
                ></app-bodyguard-services-list>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import BodyguardServicesFilters from '@components/Vigilance/Bodyguard/BodyguardServices/BodyguardServicesFilters/BodyguardServicesFilters';
import BodyguardServicesList from '@components/Vigilance/Bodyguard/BodyguardServices/BodyguardServicesList/BodyguardServicesList';
import bodyguardRepository from '@repositories/bodyguard.repository';
export default {
    name: 'bodyguard_services_administrative',
    components: {
        appBodyguardServicesFilters: BodyguardServicesFilters,
        appBodyguardServicesList: BodyguardServicesList
    },
    data: () => ({
        page: 1,
        sortBy: 'body_guard_services.created_at',
        sortDir: 'desc',
        services: null,
        filters: null
    }),
    methods: {
        async loadServices() {
            const payload = {...this.filters, sortBy: this.sortBy, sortDir: this.sortDir};

            const br = {...bodyguardRepository};

            try {

                const { data } = await br.loadBodyguardServices(payload, this.page);

                this.services = data;
            } catch(err) {
                toastr.error(`Ocurrió un error al cargar los servicios [${err.message}]`)
            }

        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDir = ctx.sortDir;
            this.loadServices();
        },
        onChangePage(page) {
            this.page = page;
            this.loadServices();
        },
        onFilter(filters) {
            this.filters = filters;
            this.page = 1;
            this.loadServices();
        },
        initialize() {
            this.loadServices();
        }
    },
    created() {
        this.initialize();
    }
}
</script>
